import { Outlet } from 'react-router-dom';
import React from 'react';
import Navbar from '../components/Navbar';
import FacebookBanner from '../images/FacebookBanner.jpg'

const MainLayout = () => {
  return (
    <>
        <Navbar/>
        <Outlet/>
        <div className='w-full flex justify-center items-center'>
          <div className='w-full md:w-2/3 lg:w-1/2 items-center'>
            <img className='h-auto w-full' src={FacebookBanner} alt='Sand Cherry Logo' />
          </div>
        </div>

    </>
  )
}

export default MainLayout
